<template>
  <div class="article-image-video-container" :class="classes">
    <div class="article-image-video">
      <div v-if="productHandle">
        <AddFromPhoto :product-handle="productHandle" :image-url="image" />
      </div>
      <div v-else>
        <Picture :images="image" />
      </div>
      <div v-if="productHandle2">
        <AddFromPhoto :product-handle="productHandle2" :image-url="image2" />
      </div>
      <div v-else>
        <Picture :images="image2" />
      </div>
      <div>
        <AddFromVideo
          v-if="videoUrl"
          :product-handle="productHandle3"
          :video-url="videoUrl"
        />
        <IntersectionObserver v-if="videoUrl2" v-slot="{ intersected }">
          <Video
            :intersected="intersected"
            :video="{
              sources: [
                {
                  url: videoUrl2,
                },
              ],
            }"
          />
        </IntersectionObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
import AddFromVideo from "@/components/AddFromVideo.vue";
import Video from "@/components/Video.vue";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
export default {
  name: "ArticleImageVideo",
  components: {
    AddFromPhoto,
    AddFromVideo,
    Picture,
    Video,
    IntersectionObserver,
  },
  props: {
    productHandle: {
      type: String,
      default: null,
    },
    productHandle2: {
      type: String,
      default: null,
    },
    productHandle3: {
      type: String,
      default: null,
    },
    image: {
      type: Object,
      required: true,
    },
    image2: {
      type: Object,
      default: null,
    },
    videoUrl: {
      type: String,
      default: null,
    },
    videoUrl2: {
      type: String,
      default: null,
    },
    flip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "article-image-video-container--flip": this.flip,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-image-video-container {
  margin: 0 0 60px;

  @include respond-above(md) {
    grid-template-columns: repeat(2, 1fr);
    margin: 0 0 80px;
  }

  &:deep(.picture__wrapper) {
    display: block;
  }

  &--flip {
    direction: rtl;
  }
}
.article-image-video {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2px;

  @include respond-above(md) {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 2px;
    margin: 0 auto;
    max-width: 1400px;
    row-gap: 0;
  }
}
</style>
